 angular.module('qkr').constant('APP_CONSTANT', setConstant());
    function setConstant() {
        return {
            REPORT_TRANSACTION_DETAILS: 'Transaction Details',
            REPORT_RECONCILIATION: 'Reconciliation',
            MENU_TYPE_FIXED: 'fixed',
            DEFAULT_SHARED_MENU_NAME: 'Menu',
            MICROS: 'Micros',
            COMTREX: 'Comtrex',
            PAYMENTEZ: 'Paymentez',
            EUNOIA: 'Eunoia',
            QUADRANET: 'Quadranet',
            IBS: 'IBS',
            PILOT: 'Pilot',
            ZONAL: 'Zonal',
            DEMO: 'Demo',
            PAYATTABLE: 'payAtTable',
            ORDERAHEADENABLED: 'orderAheadEnabled',
            INTEGRATION_POS: 'pos',
            INTEGRATION_FULFILLMENT: 'fulfillment',
            INTEGRATION_CHARITY: 'charity',
            ORDERATTABLEMENUSYNC: 'orderAtTableMenuSync',
            INTERVALSDROPDOWN: ' minutes',
            NUMERIC: 'NUMERIC',
            ALPHANUMERIC: 'ALPHANUMERIC',
            YES: 'Yes',
            NO: 'No',
	        AcceptanceDeviceModel: {
		        MEI_A5000: 'MEI-A5000',
		        AURESYS_R2: 'AURESYS-R2'
	        },
	        MachineState: {
		        ACTIVE: 'Active',
		        INACTIVE: 'Inactive'
	        },
	        PermissionType: {
		        VENDING: 'Vending',
		        DEVICE_MANAGEMENT: 'DeviceManagement'
	        },
	        BusinessCategory: {
		        VENDING: 'Vending'
	        },
		    DiscountType: {
		        NONE: 0,
		        DISCOUNT_PERCENT: 1,
			    DISCOUNT_AMOUNT: 2
	        },
            SubscriptionService: {
                ADD_SPINNER: 'addSpinner',
                REMOVE_SPINNER: 'removeSpinner',
                ADD_PARTNER_REPORT: 'addPartnerReport',
                ACCOUNTANCY_FINANCE_NON_MATCHES_COUNT: 'accountancyFinanceNonMatchesCount',
                ACCOUNTANCY_FINANCE1_PRODUCTS_COUNT : 'accountancyFinance1ProductsCount'
	        },
            REPORT_STOCK_DETAILS: 'Stock',
            AUSTRALIA_ISO_CODE: 'AU',
            DEFAULT_AUSTRALIA_BANK_CUTOFF_TIMEZONE_NAME: 'Australia/Sydney',
            DEFAULT_AUSTRALIA_BANK_CUTOFF_HOURS: 17,
            DEFAULT_AUSTRALIA_BANK_CUTOFF_MINUTES: 30,
            DEFAULT_BANK_CUTOFF_TIME: 0,
            OVER_THE_COUNTER : 'OVER_THE_COUNTER',
            INVOICE : 'INVOICE',
            FOOD : 'FOOD',
            FINANCE1_REPORT : 'Finance 1'
        };
    }



// WEBPACK FOOTER //
// ./src/constant/app.constants.js